import { useState } from 'react';

export const useFilters = (params) => {
  const { formOptions, metricDictionary } = params;

  const [filters, setFilters] = useState(formOptions);
  const [values, setValues] = useState(formOptions);
  const [selectedMetrics, setSelectedMetrics] = useState([]);

  const resetFilters = () => {
    setFilters(formOptions);
    setValues(formOptions);
    setSelectedMetrics([]);
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    const newFilters = {
      ...filters,
      [name]: value,
    };

    setFilters(newFilters);

    if (name === 'utc') {
      setValues({
        ...values,
        [name]: value,
      });
    }

    return Promise.resolve(newFilters);
  };

  const onSubmit = (e, newFilters = null) => {
    const filter = newFilters || filters;

    setValues(filter);
    const selected = metricDictionary.filter((metric) => filter.metrics.includes(metric.code));

    const sorted = selected.sort((a, b) =>
      a.title.localeCompare(b.title, undefined, {
        numeric: false,
        sensitivity: 'base',
      }),
    );

    setSelectedMetrics(sorted);
  };

  return {
    filters,
    values,
    selectedMetrics,
    resetFilters,
    onChange,
    onSubmit,
    setValues,
  };
};
